<template>
	<div v-if="isLaptop">
		<b-modal id="deleteModal-uld" centered hide-footer hide-header size="md">
			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex align-items-center ml-3 mt-3">
					<div>
						<img
							src="../../assets/candidate-documents/docs-delete-icon.svg"
							alt=""
						/>
					</div>
					<div class="candash-modal-head-uld ml-2 mb-3">Delete Document</div>
				</div>
				<div
					class="img-pos pointer rotate-on-hover"
					@click="$bvModal.hide('deleteModal-uld')"
				>
					<img src="../../assets/candidate-documents/docs-x-close.svg" alt="" />
				</div>
			</div>
			<div class="uploadDocs-caution-uld ml-4">
				Are you sure you want to delete this document? This action cannot be
				undone.
			</div>

			<div
				class="candash-modal-footer d-flex align-items-center justify-content-end mt-4 border-top-none"
			>
				<b-button
					:disabled="buttonLoader"
					class="uploadDocs-cancelbtn mr-2"
					@click="$bvModal.hide('deleteModal-uld')"
					>Cancel</b-button
				>
				<div class="uploadDocs-btn position-relative">
					<b-button
						class=""
						:class="
							buttonLoader ? ' loader-class-doc defaultCursor' : ' pointer'
						"
						@click="buttonLoader ? '' : deleteDocument()"
						>{{ buttonLoader ? "" : "Delete" }}</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="forceDelete" centered hide-footer hide-header size="md">
			<div class="d-flex align-items-center justify-content-between">
				<div class="d-flex align-items-center ml-3 mt-3">
					<div>
						<img
							src="../../assets/candidate-documents/docs-delete-icon.svg"
							alt=""
						/>
					</div>
					<div class="candash-modal-head-uld ml-2 mb-3">Delete Document</div>
				</div>
				<div
					class="img-pos pointer rotate-on-hover"
					@click="$bvModal.hide('forceDelete')"
				>
					<img src="../../assets/candidate-documents/docs-x-close.svg" alt="" />
				</div>
			</div>
			<div class="uploadDocs-caution-force ml-4">
				This document is shared to some jobs. Are you sure you want to delete
				this document? This action cannot be undone.
			</div>

			<div
				class="candash-modal-footer d-flex align-items-center justify-content-end mt-4 border-top-none"
			>
				<b-button
					:disabled="buttonLoader"
					class="uploadDocs-cancelbtn mr-2"
					@click="$bvModal.hide('forceDelete')"
					>Cancel</b-button
				>
				<div class="uploadDocs-btn position-relative">
					<b-button
						class=""
						:class="
							buttonLoader ? ' loader-class-doc defaultCursor' : ' pointer'
						"
						@click="buttonLoader ? '' : forceDelete()"
						>{{ buttonLoader ? "" : "Delete" }}</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</b-modal>
	</div>
	<div v-else>
		<b-modal id="deleteModal-uld" centered hide-footer hide-header size="md">
			<div class="d-flex align-items-center justify-content-between">
				<div
					class="d-flex align-items-center justify-content-center w-100 mt-3"
				>
					<div>
						<div class="img-margin-mob">
							<img
								src="../../assets/candidate-documents/docs-delete-icon.svg"
								alt=""
							/>
						</div>
						<div class="candash-modal-head-uld mb-2">Delete Document</div>
					</div>
				</div>
				<div
					class="img-pos pointer rotate-on-hover"
					@click="$bvModal.hide('deleteModal-uld')"
				>
					<img src="../../assets/candidate-documents/docs-x-close.svg" alt="" />
				</div>
			</div>
			<div class="uploadDocs-caution-uld-mob ml-4">
				Are you sure you want to delete this document? This action cannot be
				undone.
			</div>

			<div
				class="candash-modal-footer d-flex align-items-center justify-content-center mt-4 mb-2 border-top-none position-relative"
			>
				<b-button
					:disabled="buttonLoader"
					class="uploadDocs-cancelbtn mr-3 btn-hw-mob"
					@click="$bvModal.hide('deleteModal-uld')"
					>Cancel</b-button
				>
				<div class="uploadDocs-btn">
					<b-button
						class="btn-hw-mob"
						:class="buttonLoader ? 'loader-class-doc defaultCursor' : 'pointer'"
						@click="buttonLoader ? '' : deleteDocument()"
						>{{ buttonLoader ? "" : "Delete" }}</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="forceDelete" centered hide-footer hide-header size="md">
			<div class="d-flex align-items-center justify-content-between">
				<div
					class="d-flex align-items-center justify-content-center w-100 mt-3"
				>
					<div>
						<div class="img-margin-mob">
							<img
								src="../../assets/candidate-documents/docs-delete-icon.svg"
								alt=""
							/>
						</div>
						<div class="candash-modal-head-uld mb-2">Delete Document</div>
					</div>
				</div>
				<div
					class="img-pos pointer rotate-on-hover"
					@click="$bvModal.hide('forceDelete')"
				>
					<img src="../../assets/candidate-documents/docs-x-close.svg" alt="" />
				</div>
			</div>
			<div class="uploadDocs-caution-uld-mob ml-4">
				This document is shared to some jobs. Are you sure you want to delete
				this document? This action cannot be undone.
			</div>

			<div
				class="candash-modal-footer d-flex align-items-center justify-content-center mt-4 mb-2 border-top-none position-relative"
			>
				<b-button
					:disabled="buttonLoader"
					class="uploadDocs-cancelbtn mr-3 btn-hw-mob"
					@click="$bvModal.hide('forceDelete')"
					>Cancel</b-button
				>
				<div class="uploadDocs-btn">
					<b-button
						class="btn-hw-mob"
						:class="
							buttonLoader ? ' loader-class-doc defaultCursor' : ' pointer'
						"
						@click="buttonLoader ? '' : forceDelete()"
						>{{ buttonLoader ? "" : "Delete" }}</b-button
					>
					<div v-if="buttonLoader" class="loader-pos-new">
						<Loader />
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import toast from "../../components/mixin/toast";
import Loader from "../../components/fixedcomponents/Loader.vue";

import { deleteDocument } from "../../utils/apiFunctions.js";

export default {
	components: {
		Loader,
	},
	mixins: [toast],

	data() {
		return {
			isLaptop: true,
			buttonLoader: false,
		};
	},
	props: {
		documentID: String,
	},
	mounted() {
		window.addEventListener("resize", this.checkScreenSize);
		this.checkScreenSize();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		async deleteDocument() {
			try {
				this.buttonLoader = true;
				let payload = {
					documentID: this.documentID,
					force: false,
				};
				const response = await deleteDocument(payload);
				if (response.status == 200) {
					this.buttonLoader = false;
					this.$bvModal.hide("deleteModal-uld");
					this.$emit("updateDoc");
					this.successModal("Success", "Document deleted successfully");
					this.$bvModal.hide("deleteModal-uld");
				} else if (response.status == 207) {
					this.buttonLoader = false;
					this.$bvModal.show("forceDelete");
					this.$bvModal.hide("deleteModal-uld");
				}
			} catch (error) {
				throw error;
			}
		},
		async forceDelete() {
			try {
				this.buttonLoader = true;
				let payload = {
					documentID: this.documentID,
					force: true,
				};
				const response = await deleteDocument(payload);
				if (response.status == 200) {
					this.buttonLoader = false;
					this.$emit("updateDoc");
					this.successModal("Success", "Document deleted successfully");
					this.$bvModal.hide("forceDelete");
				}
			} catch (error) {
				throw error;
			}
		},
	},
};
</script>

<style scoped>
.mob-loader-pos-doc {
	position: absolute;
	top: -38px;
	z-index: 1;
	right: 150px;
}

.loader-pos-doc {
	position: absolute;
	top: -54px;
	z-index: 1;
	left: 0px;
}

.img-margin-mob {
	margin-left: 40px;
	margin-bottom: 20px;
}
.btn-hw-mob {
	width: 120px;
	height: 32px;
}
.uploadDocs-caution-force {
	color: #344054;
	font-size: var(--size-13);
	font-weight: 500;
	font-family: "montserrat", sans-serif;
	width: 82%;
	position: absolute;
	top: 57px;
	right: 11px;
}
</style>
